/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_SubtitleInputs */

const cs_settings_automation_subtitle = /** @type {(inputs: Settings_Automation_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflows, triggery a akce.`)
};

const en_settings_automation_subtitle = /** @type {(inputs: Settings_Automation_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflows, triggers and actions.`)
};

/**
* | output |
* | --- |
* | "Workflows, triggers and actions." |
*
* @param {Settings_Automation_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_subtitle = /** @type {((inputs?: Settings_Automation_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_subtitle(inputs)
	return cs_settings_automation_subtitle(inputs)
});